import { AuthAuthPermissions } from '@robovision/rvai-auth'
import type { RvaiAbilityBuilder } from '../types'


export function defineJobsAbility (
  builder: RvaiAbilityBuilder,
  permissions: AuthAuthPermissions[],
): void {
  const { can } = builder

  const canWrite = permissions.includes(AuthAuthPermissions.MODEL_CREATION) ||
    permissions.includes(AuthAuthPermissions.SYSTEM_MANAGEMENT)
  const canRead = canWrite || permissions.includes(AuthAuthPermissions.INFERENCE)

  if (canWrite) {
    can('crud', 'Job')
  } else if (canRead) {
    can('read', 'Job')
  }
}
